<template>
  <div>
    <div class="shadow">
      <!-- desktop header -->
      <div class="container d-none d-md-block py-3">
        <div class="row">
          <div class="col-8 d-flex align-items-end">
            <router-link tag="h1" class="display-3" to="/"
              >Jo Eckardt</router-link
            >
          </div>
          <div class="col-4">
            <img src="@/assets/jo.jpg" class="rounded float-right" />
          </div>
        </div>
      </div>

      <navigation />
    </div>

    <div class="animated-calm-bg py-3 py-md-5">
      <div class="container" v-if="$route.meta.title">
        <h2 class="display-4 d-none d-md-block">{{ $route.meta.title }}</h2>
        <h2 class="d-md-none">{{ $route.meta.title }}</h2>
      </div>
    </div>

    <div class="container my-4 my-md-5"><router-view /></div>

    <app-footer class="mt-5" />

    <transition name="fade">
      <div
        class="to-top justify-content-center align-items-center position-fixed bg-strong-blue rounded shadow-sm"
        @click="scrollTop();"
        v-show="showScrollTopButton"
      >
        <div></div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  components: {
    Navigation: () => import("@/components/Navigation"),
    AppFooter: () => import("@/components/AppFooter")
  },
  watch: {
    $route({ meta }) {
      document.title = meta.title ? `${meta.title} | Jo Eckardt` : "Jo Eckardt";
    }
  },
  data: () => ({
    waitingForRender: false,
    showScrollTopButton: false
  }),
  mounted() {
    window.addEventListener("scroll", this.onScroll, false);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll, false);
  },
  methods: {
    onScroll() {
      if (this.waitingForRender) {
        return;
      }

      this.waitingForRender = true;
      window.requestAnimationFrame(() => {
        this.showScrollTopButton = window.scrollY > 500;
        this.waitingForRender = false;
      });
    },
    scrollTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/scss/mixins";
.to-top {
  display: flex;
  bottom: $spacer;
  right: $spacer;
  width: $spacer * 3;
  height: $spacer * 3;
  opacity: 0.9;

  div {
    border: transparent 0.5rem solid;
    border-bottom-color: white;
    margin-top: -0.5rem;
  }

  &.fade-enter-active,
  &.fade-leave-active {
    transition: opacity 0.2s ease-out;
  }
  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
  }
}
</style>
